module.exports = __webpack_public_path__ + "./img/folder.5e7b2759de5e31e27c03b5eeec4c0279.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/folder.png
// module id = ./src/containers/Briefcase/entry/icons/folder.png
// module chunks = 0